import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";

export default makeStyles((theme) => ({
  active: {
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    color: theme.palette.primary.main,
    fontSize: "14px",
    fontWeight: 400
  },
  goBackButton: {
    display: "flex !important",
    alignItems: "center",
    gap: "8px",
    fontSize: "18px",
    fontWeight: "700",
    width: "fit-content",
    color: theme.palette.primary.main,
    textDecoration: "none",
    background: "none",
    border: "none",
    marginBottom: "30px",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  previewheader: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    alignItems: "center",
    "& h4": {
      fontWeight: "700",
      fontSize: "14px",
      marginBlock: "0px"
    },
    "& h5": {
      fontWeight: "800",
      fontSize: "20px",
      marginBlock: "0px"
    },
    "& h3": {
      fontWeight: "800",
      fontSize: "20px",
      color: theme.palette.primary.main,
      marginBlock: "0px"
    },
    "& h6": {
      fontWeight: "800",
      fontSize: "14px",
      color: theme.palette.primary.main,
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: "400",
      fontSize: "14px",
      marginBlock: "0px"
    },
    "@media (max-width: 410px)": {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  previewsubheader: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    alignItems: "center",
    marginBottom: "8px",
    "& h5": {
      fontWeight: "800",
      fontSize: "24px",
      color: theme.palette.primary.main,
      marginBlock: "0px"
    },
    "& h4": {
      fontWeight: "700",
      fontSize: "14px",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: "400",
      fontSize: "14px",
      marginBlock: "0px"
    }
  },
  pricingplan: {
    marginBottom: "8px",
    "& h4": {
      fontWeight: "5000",
      fontSize: "24px",
      color: theme.palette.primary.main,
      marginBlock: "0px"
    },
    "& h3": {
      fontWeight: "500",
      fontSize: "14px",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: "400",
      fontSize: "14px",
      marginBlock: "0px"
    }
  },
  icon: {
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    padding: "12px",
    borderRadius: "50%",
    width: "fit-content",
    display: "flex",
    alignItems: "center"
  },
  iconColor: {
    color: theme.palette.primary.main
  },
  container: {
    // padding: "20px",
    margin: "0 auto",
    color: "#1a1a1a",
    "& h2": {
      marginBlock: "0px 8px"
    }
  },
  alert: {
    backgroundColor: "#ffe6e6",
    color: "#b30000",
    padding: "12px",
    borderRadius: "6px",
    marginBottom: "20px",
    fontSize: "14px"
  },
  headerSection: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "30px",
    gap: "20px",
    flexWrap: "wrap"
  },
  currentSeat: {
    width: "100",
    background: "#f7f7f7",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingInline: "20px",
    borderRadius: "8px",
    marginBottom: "16px",
    "& p": {
      fontSize: "16px",
      color: "#555",
      marginBlock: "0px",
      fontWeight: "500"
    }
  },
  leftheader: {
    background: "#f7f7f7",
    textAlign: "left",
    padding: "18px",
    borderRadius: "8px",
    "& p": {
      fontSize: "16px",
      color: "#555",
      marginBlock: "0px",
      fontWeight: "500"
    }
  },
  currentSeatTitle: { fontSize: "16px", color: "#555" },
  seatCount: { fontSize: "32px", margin: "5px 0" },
  seatLabel: { fontSize: "18px", color: "#777" },
  subscription: {
    flex: 1,
    background: "#fafafa",
    padding: "20px",
    borderRadius: "8px"
  },
  subTitle: { fontSize: "16px", marginBottom: "10px" },
  pricingBox: { fontSize: "14px", lineHeight: "1.8", background: "#f7f7f7", padding: "20px", marginBlock: "16px" },
  amountDue: { fontSize: "18px", color: "#000", marginTop: "15px" },
  nextRenewal: { color: "#888", fontSize: "14px" },
  // leftItem: {
  //   background: "#f7f7f7"
  // },
  plansSection: {
    background: "#f7f7f7",
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "20px",
    marginBottom: "20px"
  },
  sliderLabel: {
    marginBottom: "10px",
    "& p": {
      fontWeight: 500,
      textAlign: "left",
      marginBlock: 0
    }
  },

  capacityLegend: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "4px",

    "& .capacityBox": {
      width: "14px",
      height: "14px",
      backgroundColor: "#d20505ff",
      borderRadius: "3px",
      flexShrink: 0
    },

    "& span": {
      fontSize: "14px",
      fontWeight: 400,
      color: "#333"
    }
  },
  slider: { width: "100%", marginBottom: "20px" },
  planTabs: { display: "flex", gap: "10px", marginBottom: "15px" },
  planBtn: {
    padding: "10px 20px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    background: "#fff",
    cursor: "pointer"
  },
  planBtnActive: {
    padding: "10px 20px",
    borderRadius: "6px",
    background: "#007bff",
    color: "#fff",
    border: "none",
    cursor: "pointer"
  },
  planOptions: { display: "flex", gap: "10px", marginBottom: "15px" },
  planOption: {
    padding: "8px 16px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    background: "#f9f9f9",
    cursor: "pointer"
  },
  planOptionActive: {
    padding: "8px 16px",
    borderRadius: "6px",
    border: "1px solid #007bff",
    background: "#e6f0ff",
    cursor: "pointer"
  },
  note: {
    padding: "8px",
    background: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    borderRadius: "6px",
    fontSize: "13px",
    textAlign: "left",
    color: "#555",
    marginBlock: "16px",
    "& p": { marginBlock: "0px" }
  },

  toggleWrapper: { margin: "20px 0" },
  toggleLabel: { fontSize: "14px", cursor: "pointer" },

  chargesBox: {
    textAlign: "left",
    background: "#fafafa",
    padding: "15px",
    borderRadius: "8px",
    fontSize: "14px",
    marginBottom: "25px",
    "& ul": {
      listStyleType: "disc",
      paddingLeft: "20px",
      margin: "8px 0px"
    },
    "& li": {
      marginBottom: "4px"
    }
  },
  pricesinfo: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBlock: "0px 8px",
    "& p": {
      color: "#667185",
      marginBlock: "0px 8px",
      fontWeight: "500"
    },
    "& h4": {
      color: "#d20505ff",
      marginBlock: "0px 8px",
      fontWeight: "500",
      fontSize: "18px"
    },
    "& h3": {
      color: "#111827",
      fontWeight: "500",
      marginBlock: "0px 8px"
    }
  },
  invoiceinfo: {
    marginBlock: "0px 8px",
    "& p": {
      color: "#667185",
      marginBlock: "0px",
      fontWeight: "500"
    },
    "& h4": {
      color: "#d20505ff",
      marginBlock: "0px 8px",
      fontWeight: "500",
      fontSize: "18px"
    },
    "& h3": {
      color: "#111827",
      fontWeight: "500",
      marginBlock: "0px 8px"
    }
  },

  modalFooterBtn: {
    color: "#fff",
    padding: "12px 24px",
    border: "none",
    borderRadius: "8px",
    fontSize: "16px",
    cursor: "pointer",
    display: "block",
    maxWidth: "250px",
    margin: "0 auto"
  },
  // FOR SLIDER
  wrapper: {
    width: "100%",
    // maxWidth: 600,
    margin: "auto"
  },
  sliderBox: {
    marginBottom: 20,
    display: "flex",
    alignItems: "center",
    gap: "10px"
  },
  sliderLabels: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: 12,
    marginTop: 16
  },
  categories: {
    background: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    border: "6px",
    display: "flex",
    padding: "16px",
    justifyContent: "center",
    gap: "12px",
    flexWrap: "wrap",
    margin: "20px 0"
  },
  categoryBtn: {
    padding: "10px 20px",
    borderRadius: "8px",
    border: "1px solid #FFF",
    color: theme.palette.primary.main,
    background: "none",
    cursor: "pointer",
    fontWeight: "700"
  },
  activeCategory: {
    background: theme.palette.primary.main,
    color: "#fff",
    border: "none"
  },
  plans: {
    display: "flex",
    justifyContent: "center",
    gap: "15px",
    flexWrap: "wrap"
  },
  highlightCard: {
    // borderColor: `1px solid ${theme.palette.primary.main}`,
    cursor: "pointer",
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    boxShadow: `0 6px 16px ${tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString()}`,
    "& h4, & p": {
      color: theme.palette.primary.main,
      marginBlock: "4px"
    }
  },
  selectedCard: {
    border: `1px solid ${theme.palette.primary.main}`,
    cursor: "pointer",
    backgroundColor: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    boxShadow: `0 6px 16px ${tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString()}`,
    "& h4, & p": {
      color: theme.palette.primary.main,
      marginBlock: "4px"
    }
  },
  planCard: {
    // border: "1px solid #eee",
    borderRadius: "10px",
    cursor: "pointer",
    padding: "15px",
    minWidth: "150px",
    textAlign: "center",
    background: "#fafafa",
    "& h4, & p": {
      marginBlock: "4px"
    }
  },
  // MODal

  invoiceHeader: {
    borderBottom: "1px solid #ddd",
    paddingBottom: "10px",
    marginBottom: "20px"
  },
  invoiceBody: {
    marginBottom: "20px"
  },
  invoiceFooter: {
    borderTop: "1px solid #ddd",
    paddingTop: "15px",
    marginTop: "20px",
    textAlign: "right"
  },
  // For DownGrade
  downgradeContainer: {
    padding: "20px",
    margin: "0 auto",
    color: "#1a1a1a",
    textAlign: "left",
    "& h2": {
      marginBlock: "0px 8px"
    }
  },
  plansContainer: {
    marginBottom: "32px"
  },
  aplanCard: {
    flex: 1,
    padding: "24px",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
  },
  manageseats: {
    display: "flex",
    gap: "10px",
    padding: "10px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    maxWidth: "200px",
    marginBottom: "10px",
    "& p": {
      marginBlock: "0px"
    }
  },
  proPlanCard: {
    backgroundColor: "#f0f4ff",
    borderColor: "#d0d9ff",
    cursor: "pointer"
  },
  basicPlanCard: {
    backgroundColor: "#f9f9f9"
  },
  planTitle: {
    fontSize: "1.1rem",
    fontWeight: 600,
    marginBottom: "8px",
    color: "#333",
    margin: "0 0 8px 0"
  },
  planSeats: {
    fontSize: "1.5rem",
    fontWeight: "500",
    color: "#1a1a1a",
    marginBottom: "16px",
    margin: "0 0 16px 0"
  },
  planFeatures: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap"
  },
  featureChip: {
    backgroundColor: "rgba(0,0,0,0.1)",
    color: "#666",
    fontSize: "0.85rem",
    padding: "4px 12px",
    borderRadius: "16px",
    display: "inline-block"
  },
  comparisonTable: {
    marginBottom: "24px"
  },
  comparisonTableHead: {
    backgroundColor: "#f5f5f5"
  },
  comparisonTableCellHead: {
    fontWeight: 600,
    color: "#333",
    fontSize: "1rem"
  },
  comparisonTableCellBody: {
    fontSize: "0.95rem",
    color: "#555"
  },
  comparisonTableRowEven: {
    backgroundColor: "#fafafa"
  },
  // DOWNGRADE
  variantSection: {
    marginTop: "24px",
    padding: "20px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    border: "1px solid #e9ecef",
    "& h3": {
      marginBlock: "0px 8px"
    }
  },

  variantsContainer: {
    marginTop: "16px"
  },

  variantCard: {
    position: "relative",
    padding: "20px",
    backgroundColor: "#ffffff",
    border: "2px solid #e9ecef",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    height: "100%",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",

    "&:hover": {
      borderColor: theme.palette.primary.main,
      boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
      transform: "translateY(-2px)"
    }
  },

  selectedVariantCard: {
    borderColor: theme.palette.primary.main,
    backgroundColor: "#f8fdff",
    boxShadow: `0 4px 12px ${theme.palette.primary.main}20`
  },

  selectedBadge: {
    position: "absolute",
    top: "12px",
    right: "12px",
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff",
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "600"
  },

  variantPrice: {
    fontSize: "16px",
    margin: "12px 0 0 0",
    color: theme.palette.primary.main
  },
  // Add to your styles
  currentPlanSection: {
    marginBottom: "32px",
    padding: "20px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    border: "1px solid #e9ecef"
  },
  currentPlanCard: {
    padding: "25px",
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    // border: "2px solid #007bff",
    position: "relative",
    "&::before": {
      content: '"CURRENT PLAN"',
      position: "absolute",
      top: "10px",
      right: "10px",
      color: "#fff",
      padding: "4px 8px",
      zIndex: 1,
      fontSize: "8px",
      background: theme.palette.primary.main,
      fontWeight: 700,
      borderRadius: "4px"
    }
  },
  currentPlanHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px"
  },
  currentBadge: {
    backgroundColor: "#007bff",
    color: "#ffffff",
    padding: "4px 12px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "600"
  },
  currentPlanDetails: {
    "& p": {
      margin: "8px 0",
      fontSize: "14px"
    }
  },
  selectedIndicator: {
    position: "absolute",
    top: "12px",
    right: "12px",
    backgroundColor: "#28a745",
    color: "#ffffff",
    padding: "4px 8px",
    borderRadius: "12px",
    fontSize: "12px",
    fontWeight: "600"
  },
  noPlansMessage: {
    textAlign: "center",
    padding: "40px",
    color: "#6c757d",
    fontSize: "16px"
  },
  planCategorySection: {
    marginBottom: "32px",
    padding: "20px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    border: "1px solid #e9ecef"
  },
  categoryTitle: {
    fontSize: "1.2rem",
    fontWeight: "600",
    marginBottom: "16px",
    color: "#333",
    borderBottom: "2px solid #dee2e6",
    paddingBottom: "8px"
  },
  // DOWNGRADE MODAL
  downgradeWarning: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    backgroundColor: "#fff3cd",
    border: "1px solid #ffeaa7",
    padding: "16px",
    borderRadius: "8px",
    marginBlock: "20px 0px",
    "& h4": {
      margin: 0,
      color: "#856404"
    }
  },
  planComparison: {
    marginBottom: "20px",
    "& h4": {
      marginBottom: "12px"
    }
  },
  comparisonGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "12px",
    "@media (max-width: 768px)": {
      gridTemplateColumns: "1fr"
    }
  },
  comparisonItem: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
    borderBottom: "1px solid #eee"
  },
  comparisonLabel: {
    fontWeight: "600",
    color: "#666"
  },
  currentPlan: {
    color: "#007bff",
    fontWeight: "600"
  },
  newPlan: {
    color: "#28a745",
    fontWeight: "600"
  },
  seatChange: {
    color: "#dc3545",
    fontWeight: "600"
  },
  priceChange: {
    color: "#ffc107",
    fontWeight: "600",
    fontSize: "14px"
  },
  criticalWarning: {
    backgroundColor: "#f8d7da",
    border: "1px solid #f5c6cb",
    padding: "16px",
    borderRadius: "8px",
    // marginBottom: "20px",
    "& h4": {
      color: "#721c24",
      marginBottom: "12px"
    },
    "& ul": {
      margin: 0
      // paddingLeft: "20px"
    },
    "& li": {
      marginBottom: "8px",
      color: "#721c24"
    }
  },
  highlightWarning: {
    color: "#dc3545",
    fontWeight: "500"
  },
  featureComparison: {
    marginBottom: "20px",
    "& h4": {
      marginBottom: "12px"
    }
  },
  featureTable: {
    marginBottom: "16px"
  },
  confirmationSection: {
    marginBottom: "20px",
    "& h4": {
      marginBottom: "12px"
    }
  },
  checkboxGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "12px"
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    cursor: "pointer",
    '& input[type="checkbox"]': {
      marginTop: "4px"
    }
  },
  modalActions: {
    display: "flex",
    // justifyContent: "flex-end",
    gap: "12px",
    marginTop: "24px",
    paddingTop: "16px",
    borderTop: "1px solid #dee2e6"
  },
  // FOR CUSTOM FILEDS
  item: {
    padding: "20px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    marginBottom: "20px"
  },
  changepassword: {
    fontSize: "24px",
    fontWeight: "500",
    textAlign: "left",
    marginBlock: "0px",
    color: "#333"
  },
  passwordtext: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "0"
  },
  quelabel: {
    textAlign: "left",
    display: "flex",
    color: "#545962",
    fontSize: "14px",
    fontWeight: "700"
  },
  textandimg: {
    position: "relative",
    borderRadius: "6px",
    border: "1px solid hsl(0, 0%, 80%)",
    backgroundColor: "white",
    height: "150px",
    "& textarea": {
      width: "100%",
      height: "150px",
      boxSizing: "border-box",
      background: "none",
      border: "0px",
      paddingBlock: "10px",
      paddingLeft: "10px",
      paddingRight: "35px",
      color: "black"
    }
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px"
  },
  tableContainer: {
    width: "100%"
  },
  createForm: {
    padding: "20px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    marginTop: "20px"
  },
  formTitle: {
    fontSize: "20px",
    fontWeight: "500",
    marginBottom: "20px",
    textAlign: "left",
    color: "#333"
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  formRow: {
    marginBottom: "16px"
  },
  inputField: {
    width: "100%"
  },
  selectField: {
    width: "100%",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc"
  },
  buttonContainer: {
    marginTop: "20px",
    justifyContent: "center"
  },
  checkboxGroupItem: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginTop: "16px"
  },
  checkboxLabelItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#545962",
    cursor: "pointer"
  },
  checkbox: {
    width: "16px",
    height: "16px",
    cursor: "pointer"
  },
  fieldGroup: {
    padding: "20px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    marginBottom: "20px",
    backgroundColor: "#fff"
  },
  fieldHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom: "16px",
    paddingBottom: "10px",
    borderBottom: "1px solid #f0f0f0"
  },
  fieldTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
    margin: 0
  },
  removeFieldButton: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#ff4444",
    padding: "4px",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "#ffeeee"
    }
  },
  addAnotherContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
    paddingTop: "20px",
    borderTop: "1px dashed #e0e0e0"
  },
  addAnotherButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    background: "none",
    border: "1px dashed #1976d2",
    color: "#1976d2",
    padding: "10px 16px",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    "&:hover": {
      backgroundColor: "#f0f8ff",
      borderStyle: "solid"
    }
  },
  // Netflix-style pricing table
  pricingTableContainer: {
    background: "#fff",
    borderRadius: "12px",
    padding: "32px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    marginBottom: "32px"
  },

  pricingTable: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: "24px",
    "& th, & td": {
      padding: "16px",
      textAlign: "center",
      borderBottom: "1px solid #e8e8e8"
    },
    "& th": {
      fontWeight: "600",
      fontSize: "14px",
      color: "#333",
      background: "#fafafa"
    },
    "& td": {
      fontSize: "14px",
      color: "#666"
    }
  },

  planHeader: {
    background: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    color: "#000000ff !important",
    borderRadius: "8px 8px 0 0",
    padding: "20px !important",
    "& h3": {
      margin: "0 0 8px 0",
      fontSize: "24px",
      fontWeight: "700"
    },
    "& .price": {
      fontSize: "32px",
      fontWeight: "700",
      margin: "8px 0"
    },
    "& .period": {
      fontSize: "14px",
      opacity: "0.9"
    }
  },
  toggleVariant: {
    marginTop: "8px",
    padding: "4px 8px",
    margin: "auto",
    width: "100px",
    fontSize: "12px",
    background: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    border: theme.palette.primary.main,
    borderRadius: "4px",
    color: theme.palette.primary.main,
    cursor: "pointer"
  },
  toggledVariantDeets: {
    background: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    fontWeight: "600 !important",
    textAlign: "left !important",
    padding: "18px !important"
  },
  backgroundOnly: {
    background: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString()
  },

  featureRow: {
    "&:hover": {
      backgroundColor: "#f8f9fa"
    }
  },
  selectTable: {
    margin: "auto",
    width: "150px"
  },
  selectagain: {
    margin: "auto",
    width: "200px",
    "& h4": {
      marginBlock: "0px 0px"
    }
  },

  featureName: {
    textAlign: "left !important",
    fontWeight: "500 !important",
    color: "#333 !important",
    background: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString()
  },

  checkmark: {
    color: "#28a745",
    fontSize: "18px"
  },

  cross: {
    color: "#dc3545",
    fontSize: "18px"
  },

  variantToggle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    margin: "16px 0",
    "& button": {
      padding: "8px 16px",
      border: "1px solid #ddd",
      background: "#fff",
      borderRadius: "6px",
      cursor: "pointer",
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: "#E50914"
      },
      "&.active": {
        background: "#E50914",
        color: "#fff",
        borderColor: "#E50914"
      }
    }
  },

  currentPlanBadgeTable: {
    background: "#28a745",
    color: "#fff",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    marginTop: "8px",
    width: "130px"
  },

  // Netflix-style card
  netflixCard: {
    background: "#fff",
    borderRadius: "12px",
    padding: "0",
    overflow: "hidden",
    position: "relative",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
    border: "2px solid transparent",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 30px rgba(0, 0, 0, 0.15)"
    },
    "&.current": {
      borderColor: theme.palette.primary.main,
      "&::before": {
        content: '"CURRENT PLAN"',
        position: "absolute",
        top: "12px",
        right: "12px",
        background: theme.palette.primary.main,
        color: "#fff",
        padding: "4px 8px",
        borderRadius: "4px",
        fontSize: "10px",
        fontWeight: "700",
        zIndex: 1
      }
    },
    "&.recommended": {
      // borderColor: "#E50914",
      position: "relative",
      "&::before": {
        content: '"RECOMMENDED"',
        position: "absolute",
        top: "12px",
        right: "12px",
        background: "#E50914",
        color: "#fff",
        padding: "4px 8px",
        borderRadius: "4px",
        fontSize: "10px",
        fontWeight: "700",
        zIndex: 1
      }
    }
  },

  cardHeader: {
    background: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    color: "#030303ff",
    padding: "24px",
    height: "130px",
    textAlign: "center",
    position: "relative",
    "& h3": {
      margin: "0 0 0 0",
      fontSize: "20px",
      fontWeight: "700",
      textAlign: "left"
    },
    "& .price": {
      fontSize: "28px",
      fontWeight: "700",
      margin: "8px 0",
      "& h3": {
        fontWight: "500",
        marginBlock: "0px"
      }
    },
    "& .period": {
      fontSize: "14px",
      opacity: "0.9"
    }
  },

  variantIndicator: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    marginTop: "8px",
    fontSize: "12px",
    opacity: "0.9"
  },

  variantOptions: {
    marginTop: "16px",
    padding: "16px",
    background: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
    borderRadius: "8px",
    border: "1px solid rgba(229, 9, 20, 0.1)",
    "& h4": {
      margin: "0 0 12px 0",
      fontSize: "14px",
      fontWeight: "600",
      color: "#333"
    }
  },

  variantOption: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 12px",
    marginBottom: "8px",
    background: "#fff",
    border: "1px solid #e0e0e0",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#E50914",
      background: "rgba(229, 9, 20, 0.02)"
    },
    "&:last-child": {
      marginBottom: "0"
    }
  },

  variantInfo: {
    display: "flex",
    flexDirection: "column",
    "& strong": {
      fontSize: "14px",
      fontWeight: "600"
    },
    "& span": {
      fontSize: "12px",
      color: "#666",
      textAlign: "left"
    }
  },

  cardBody: {
    padding: "14px 24px",
    flex: "1",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    height: "250px",
    "& ul": {
      listStyle: "none",
      padding: "0",
      margin: "0",
      flex: "1"
    },
    "& li": {
      padding: "8px 0",
      borderBottom: "1px solid #f0f0f0",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "14px",
      "&:last-child": {
        borderBottom: "none"
      }
    }
  },

  cardFooter: {
    padding: "0 24px 24px 24px",
    "& > div": {
      width: "100%",
      padding: "12px",
      border: "none",
      borderRadius: "6px",
      fontSize: "16px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "all 0.2s ease",
      "&.primary": {
        background: theme.palette.primary.main,
        color: "#fff",
        "&:hover": {
          background: tinycolor(theme.palette.primary.main).lighten(10).setAlpha(0.07).toRgbString(),
          color: theme.palette.primary.main
        }
      },
      "&.secondary": {
        background: "#f8f9fa",
        color: "#333",
        border: "1px solid #ddd",
        "&:hover": {
          background: "#e9ecef"
        }
      }
    }
  },

  // Modal styles for downgrade
  downgradeModal: {
    "& .MuiDialog-paper": {
      borderRadius: "12px",
      maxWidth: "600px",
      width: "90%"
    }
  },

  modalHeader: {
    padding: "24px 24px 0 24px",
    textAlign: "center",
    "& h2": {
      margin: "0 0 8px 0",
      color: "#333",
      fontSize: "24px"
    },
    "& p": {
      margin: "0",
      color: "#666",
      fontSize: "14px"
    }
  },

  modalBody: {
    padding: "24px",
    "& .comparison": {
      background: "#f8f9fa",
      borderRadius: "8px",
      padding: "16px",
      marginBottom: "16px"
    }
  },
  fullwidth: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start"
  },
  invoiceContainer: {
    padding: "10px",
    borderRadius: "12px",
    color: "#222",
    textAlign: "left",
    width: "100%",
    "@media (max-width: 768px)": {
      padding: "8px",
      borderRadius: "8px"
    }
  },

  invoiceheader: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "10px",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      gap: "15px",
      marginBottom: "15px"
    }
  },

  headerLeft: {
    "& h1": {
      fontSize: "22px",
      fontWeight: 700,
      margin: 0,
      "@media (max-width: 768px)": {
        fontSize: "18px"
      }
    },
    "& p": {
      color: "#6c757d",
      fontSize: "20px",
      margin: 0,
      "@media (max-width: 768px)": {
        fontSize: "14px"
      }
    },
    "@media (max-width: 768px)": {
      width: "100%"
    }
  },

  headerRight: {
    display: "flex",
    alignItems: "center",
    textAlign: "right",
    gap: "10px",
    "@media (max-width: 768px)": {
      width: "100%",
      justifyContent: "space-between",
      textAlign: "left",
      flexDirection: "row-reverse"
    }
  },

  statusBadge: {
    padding: "1px 12px",
    borderRadius: "20px",
    fontSize: "14px",
    fontWeight: 400,
    display: "inline-block",
    marginBottom: "5px",
    textTransform: "capitalize",
    "@media (max-width: 768px)": {
      fontSize: "12px",
      padding: "2px 10px"
    }
  },

  invoiceNumber: {
    "& small": {
      display: "block",
      fontSize: "18px",
      color: "#6c757d",
      "@media (max-width: 768px)": {
        fontSize: "14px"
      }
    },
    "& span": {
      fontWeight: 700,
      fontSize: "16px",
      "@media (max-width: 768px)": {
        fontSize: "14px"
      }
    }
  },

  detailItem: {
    "& label": {
      display: "block",
      fontSize: "12px",
      color: "#667185",
      marginBottom: "3px",
      "@media (max-width: 768px)": {
        fontSize: "11px"
      }
    },
    "& p": {
      margin: 0,
      fontSize: "14px",
      fontWeight: 400,
      "@media (max-width: 768px)": {
        fontSize: "13px"
      }
    }
  },

  invoiceParties: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "30px",
    borderTop: "1px solid #eee",
    marginBottom: "30px",
    "& p": {
      margin: "0 0 4px 0",
      fontSize: "14px"
    },
    "@media (max-width: 768px)": {
      flexDirection: "column",
      gap: "20px",
      marginTop: "20px",
      marginBottom: "20px",
      "& p": {
        fontSize: "13px"
      }
    }
  },

  invoiceTableSection: {
    marginTop: "10px",
    "@media (max-width: 768px)": {
      marginTop: "15px",
      overflowX: "auto"
    }
  },

  invoiceTable: {
    width: "100%",
    borderCollapse: "collapse",
    "& th": {
      textAlign: "left",
      fontSize: "13px",
      color: "#6c757d",
      paddingBottom: "10px",
      borderBottom: "1px solid #eee",
      "@media (max-width: 768px)": {
        fontSize: "11px",
        padding: "8px 4px",
        whiteSpace: "nowrap"
      }
    },
    "& td": {
      padding: "12px 0",
      fontSize: "14px",
      borderBottom: "1px solid #f1f1f1",
      "@media (max-width: 768px)": {
        fontSize: "12px",
        padding: "8px 4px",
        whiteSpace: "nowrap"
      }
    },
    "@media (max-width: 768px)": {
      minWidth: "600px"
    }
  },

  summaryContainer: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "20px",
    "@media (max-width: 768px)": {
      justifyContent: "flex-start"
    }
  },

  summaryWrapper: {
    width: "260px",
    "@media (max-width: 768px)": {
      width: "100%"
    }
  },

  summaryRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "14px",
    color: "#444",
    padding: "5px 0",
    "@media (max-width: 768px)": {
      fontSize: "13px",
      padding: "4px 0"
    }
  },

  grandTotal: {
    fontWeight: 700,
    borderTop: "1px solid #ddd",
    marginTop: "10px",
    paddingTop: "10px",
    color: "#007bff",
    "@media (max-width: 768px)": {
      marginTop: "8px",
      paddingTop: "8px"
    }
  },

  invoicefooter: {
    marginTop: "40px",
    textAlign: "right",
    "@media (max-width: 768px)": {
      marginTop: "30px",
      textAlign: "center"
    }
  },

  printButton: {
    display: "inline-flex",
    alignItems: "center",
    backgroundColor: "transparent",
    border: "none",
    color: "#007bff",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 500,
    "& svg": {
      marginRight: "6px",
      fontSize: "18px"
    },
    "&:hover": {
      textDecoration: "underline"
    },
    "@media (max-width: 768px)": {
      fontSize: "13px",
      "& svg": {
        fontSize: "16px",
        marginRight: "4px"
      }
    }
  },

  fordesc: {
    color: "#000",
    fontWeight: "500",
    textAlign: "left",
    marginBlock: "0px 5px",
    "@media (max-width: 768px)": {
      fontSize: "14px"
    }
  },

  schoolInfo: {
    borderTop: "1px solid #2d2d2dff",
    borderBottom: "1px solid #2d2d2dff",
    padding: "8px 0",
    margin: "0px 0px",
    "@media (max-width: 768px)": {
      padding: "6px 0"
    }
  },

  infoRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "4px 0",
    "@media (max-width: 768px)": {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "2px",
      padding: "6px 0"
    }
  },

  label: {
    fontWeight: "500",
    color: "#666",
    fontSize: "14px",
    "@media (max-width: 768px)": {
      fontSize: "12px"
    }
  },

  value: {
    fontWeight: "400",
    color: "#000000ff",
    fontSize: "14px",
    textAlign: "right",
    "@media (max-width: 768px)": {
      fontSize: "13px",
      textAlign: "left"
    }
  },

  statusDescription: {
    fontSize: "16px",
    color: "#666",
    marginBottom: "20px",
    display: "flex",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    "@media (max-width: 768px)": {
      fontSize: "14px",
      gap: "8px",
      marginBottom: "15px",
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },

  historyBadge: {
    padding: "8px 20px",
    borderRadius: "12px",
    fontSize: "13px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    boxShadow: "0 3px 6px rgba(0,0,0,0.08)",
    border: "2px solid transparent",
    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
    position: "relative",
    overflow: "hidden",
    "&:before": {
      content: '""',
      position: "absolute",
      top: "50%",
      left: "12px",
      transform: "translateY(-50%)",
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: "currentColor",
      boxShadow: "0 0 8px currentColor"
    },
    paddingLeft: "32px",
    "&:after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%)",
      borderRadius: "10px"
    },
    "@media (max-width: 768px)": {
      padding: "6px 16px",
      fontSize: "11px",
      paddingLeft: "28px",
      "&:before": {
        left: "10px",
        width: "6px",
        height: "6px"
      }
    }
  },

  statusPending: {
    background: "linear-gradient(135deg, #FFF3CD 0%, #FFEAA7 100%)",
    color: "#856404",
    borderColor: "#F39C12",
    "&:hover": {
      transform: "translateY(-2px) scale(1.02)",
      boxShadow: "0 6px 12px rgba(243, 156, 18, 0.25)"
    }
  },

  statusApproved: {
    background: "linear-gradient(135deg, #D1ECF1 0%, #B8DAE4 100%)",
    color: "#0C5460",
    borderColor: "#27AE60",
    "&:hover": {
      transform: "translateY(-2px) scale(1.02)",
      boxShadow: "0 6px 12px rgba(39, 174, 96, 0.25)"
    }
  },

  statusOther: {
    background: "linear-gradient(135deg, #F8D7DA 0%, #F1AEB5 100%)",
    color: "#721C24",
    borderColor: "#E74C3C",
    "&:hover": {
      transform: "translateY(-2px) scale(1.02)",
      boxShadow: "0 6px 12px rgba(231, 76, 60, 0.25)"
    }
  },

  paymentBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    "@media (max-width: 768px)": {
      fontSize: "10px",
      padding: "3px 8px"
    }
  },

  invoicemain: {
    maxWidth: "1400px",
    margin: "auto",
    marginTop: "30px",
    "@media (max-width: 768px)": {
      marginTop: "15px",
      padding: "0 10px"
    }
  },

  modalFooter: {
    padding: "16px 24px 24px 24px",
    display: "flex",
    gap: "12px",
    justifyContent: "flex-end",
    borderTop: "1px solid #e8e8e8",
    "@media (max-width: 768px)": {
      padding: "12px 16px 16px 16px",
      flexDirection: "column",
      gap: "8px"
    }
  },

  logoContent: {
    height: "40px",
    "@media (max-width: 768px)": {
      height: "32px"
    }
  },

  mobileStack: {
    "@media (max-width: 768px)": {
      flexDirection: "column",
      gap: "10px"
    }
  },

  mobileFullWidth: {
    "@media (max-width: 768px)": {
      width: "100%"
    }
  },

  mobileTextCenter: {
    "@media (max-width: 768px)": {
      textAlign: "center"
    }
  },

  mobileHidden: {
    "@media (max-width: 768px)": {
      display: "none"
    }
  },

  mobileShow: {
    display: "none",
    "@media (max-width: 768px)": {
      display: "block"
    }
  }
}));
